<template>
  <a-menu v-model="current" mode="horizontal" @click="handelClick">
    <a-menu-item key="hangqing"> 行情 </a-menu-item>
    <a-menu-item key="hushi"> 沪市主板 </a-menu-item>
    <a-menu-item key="shenshi"> 深市主板 </a-menu-item>
    <a-menu-item key="chuangye"> 创业板 </a-menu-item>
    <a-menu-item key="kechuang"> 科创板 </a-menu-item>
    <a-menu-item key="stl"> ST类 </a-menu-item>
    <a-menu-item key="cxg"> 次新股 </a-menu-item>
    <a-menu-item key="bjg"> 北交所 </a-menu-item>
    <!-- <a-sub-menu key="hy">
      <span slot="title" class="submenu-title-wrapper">行业</span>
      <a-menu-item-group title="全部">
        <a-menu-item v-for="(i,idx) in plate" :key="i.id" @click="btnClick(i.id)">
          {{ i.name }}
        </a-menu-item>
      </a-menu-item-group>
    </a-sub-menu>
    <a-sub-menu key="gn">
      <span slot="title" class="submenu-title-wrapper ">概念</span>
      <a-menu-item-group title="全部" class="concept-div">
        <a-menu-item v-for="(i,idx) in concept" :key="i.id">
          {{ i.name }}
        </a-menu-item>
      </a-menu-item-group>

    </a-sub-menu>
    <a-sub-menu key="area">
      <span slot="title" class="submenu-title-wrapper">地区</span>
      <a-menu-item-group title="全部">
        <a-menu-item v-for="(i,idx) in area" :key="i.id">
          {{ i.name }}
        </a-menu-item>
      </a-menu-item-group>
    </a-sub-menu> -->
  </a-menu>
</template>

<script>
import Vue from 'vue'
import {apiStockCateList} from "@/utils/requestapis";

export default {
  name: "TopMenu",
  data(){
    return {
      area:[],
      concept:[],
      plate:[],
      current:["hangqing"]
    }
  },
  mounted(){
    // apiStockCateList({cate_type:10}).then((res) => {
    //   this.plate = res;
    // })
    // apiStockCateList({cate_type:11}).then((res) => {
    //   this.concept = res;
    // })
    // apiStockCateList({cate_type:12}).then((res) => {
    //   this.area = res;
    // })
  },
  methods: {
    btnClick(idx){
      this.$emit('fatherMethod',idx);
    },
    handelClick({ item, key, keyPath }) {
      let len  = keyPath.length;
      if(len == 1){
        this.current = [key]
      }else {
        this.current = [keyPath[1]]
      }
       //1-沪市 2-深市 3-创业板 4-科创板 5-ST类 6-次新股 7-北交所
      let idx = ''
      switch (key) {
        case "hangqing":
          idx = 0;
          break;
        case "hushi":
          idx = 1;
          break;
        case "shenshi":
          idx = 2;
          break;
        case "chuangye":
          idx = 3;
          break;
        case "kechuang":
          idx = 4;
          break;
        case "stl":
          idx = 5;
          break;
        case "cxg":
          idx = 6;
          break;
        case "bjg":
          idx = 7;
          break;
        default:
          idx = key;
          break;
      }
      if(idx < 8){
        this.$emit('fatherMethod',idx);
      }
    },
    edit(key) {
      this.current = [key]
    },
  }
}
</script>

<style lang="scss">
.ant-menu-item-group-list {
  width: 500px;color: var(--theme-text);
  background-color: var(--theme-header);
}
.concept-div>.ant-menu-item-group-list{
  width: 900px;
  overflow-y: scroll;
  max-height: 500px;
}
  //.ant-menu-item-group-list{
  //  background-color: var(--theme-header);
  //}
  .ant-menu-item {

    display: inline-block !important;
    //background-color: var(--theme-header);
  }

.ant-menu-item-group-title {
  background-color: var(--theme-header);
  color: var(--theme-text) !important;
}
.ant-menu-horizontal > .ant-menu-item:hover, .ant-menu-horizontal > .ant-menu-submenu:hover, .ant-menu-horizontal > .ant-menu-item-active, .ant-menu-horizontal > .ant-menu-submenu-active, .ant-menu-horizontal > .ant-menu-item-open, .ant-menu-horizontal > .ant-menu-submenu-open, .ant-menu-horizontal > .ant-menu-item-selected, .ant-menu-horizontal > .ant-menu-submenu-selected {
  color: var(--theme-text) !important;
  border-bottom: 2px solid #fff !important;
}
</style>